(function () {
  'use strict';

  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('[data-cart-drawer-panel]');
  const overlay = drawer.querySelector('[data-cart-drawer-overlay]');
  const itemsEl = drawer.querySelector('[data-cart-drawer-items]');
  const emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
  const footerEl = drawer.querySelector('[data-cart-drawer-footer]');
  const subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  const countEl = drawer.querySelector('[data-cart-drawer-count]');
  const autoOpen = drawer.getAttribute('data-auto-open') !== 'false';

  let isOpen = false;
  let hasRendered = false;
  let pending = false;
  let lastFocus = null;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '$0.00';
    const amount = (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const format = window.Ajura?.moneyFormat || '${{amount}}';
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function syncBadges(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('hidden', cart.item_count === 0);
    });
    document.querySelectorAll('[data-cart-drawer-toggle]').forEach((el) => {
      el.setAttribute('aria-label', 'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
    });
  }

  function lineHtml(item) {
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="text-[10px] uppercase tracking-widest font-inter text-slate/60 mt-1">' + escapeHtml(item.variant_title) + '</p>'
      : '';
    const img = item.image
      ? '<img src="' + escapeHtml(imageUrl(item.image, 240)) + '" alt="' + escapeHtml(item.product_title) + '" class="w-full h-full object-cover" loading="lazy">'
      : '';

    return (
      '<div class="flex gap-4 py-6 border-b border-slate/10" data-line-key="' + escapeHtml(item.key) + '">' +
        '<a href="' + escapeHtml(item.url) + '" class="block w-20 shrink-0">' +
          '<div class="aspect-[3/4] bg-white/40 overflow-hidden">' + img + '</div>' +
        '</a>' +
        '<div class="flex-1 min-w-0 flex flex-col">' +
          '<a href="' + escapeHtml(item.url) + '" class="font-inter text-sm font-medium text-onyx leading-snug">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          '<p class="font-inter text-sm text-slate/50 mt-1">' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="flex items-center justify-between mt-auto pt-3">' +
            '<div class="flex items-center border border-slate/20 h-8">' +
              '<button type="button" data-drawer-minus class="w-8 h-full flex items-center justify-center hover:bg-onyx/5 transition-colors text-slate" aria-label="Decrease quantity">' +
                '<svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"></line></svg>' +
              '</button>' +
              '<input type="text" value="' + item.quantity + '" data-drawer-qty readonly aria-label="Quantity" class="w-8 h-full bg-transparent text-center text-sm focus:outline-none font-inter">' +
              '<button type="button" data-drawer-plus class="w-8 h-full flex items-center justify-center hover:bg-onyx/5 transition-colors text-slate" aria-label="Increase quantity">' +
                '<svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>' +
              '</button>' +
            '</div>' +
            '<button type="button" data-drawer-remove class="text-[9px] uppercase tracking-[0.2em] font-inter font-bold text-slate/50 hover:text-onyx transition-colors" aria-label="Remove ' + escapeHtml(item.product_title) + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function render(cart) {
    hasRendered = true;
    syncBadges(cart);
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

    if (!cart.items.length) {
      itemsEl.innerHTML = '';
      itemsEl.classList.add('hidden');
      footerEl.classList.add('hidden');
      emptyEl.classList.remove('hidden');
      return;
    }

    emptyEl.classList.add('hidden');
    itemsEl.classList.remove('hidden');
    footerEl.classList.remove('hidden');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
    itemsEl.innerHTML = cart.items.map(lineHtml).join('');
  }

  function refresh() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        render(cart);
        return cart;
      })
      .catch(() => null);
  }

  function openDrawer(trigger) {
    if (isOpen) return;
    isOpen = true;
    // The add-to-bag button is disabled while the fetch is in flight, which blurs it, so
    // document.activeElement is <body> by the time cart:added fires. Prefer the explicit trigger.
    lastFocus = trigger instanceof Element ? trigger : document.activeElement;
    drawer.classList.remove('pointer-events-none');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    overlay.classList.remove('opacity-0');
    panel.classList.remove('translate-x-full');
    document.body.style.overflow = 'hidden';
    setTimeout(() => panel.focus(), 60);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.add('pointer-events-none');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    overlay.classList.add('opacity-0');
    panel.classList.add('translate-x-full');
    document.body.style.overflow = '';
    if (lastFocus && document.body.contains(lastFocus)) lastFocus.focus();
  }

  function changeLine(key, quantity) {
    if (pending) return;
    pending = true;
    itemsEl.classList.add('opacity-50', 'pointer-events-none');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then((r) => {
        if (!r.ok) throw new Error('Cart change failed');
        return r.json();
      })
      .then(render)
      .catch(() => refresh())
      .finally(() => {
        pending = false;
        itemsEl.classList.remove('opacity-50', 'pointer-events-none');
      });
  }

  // Line item controls (delegated)
  itemsEl.addEventListener('click', (e) => {
    const line = e.target.closest('[data-line-key]');
    if (!line) return;
    const key = line.getAttribute('data-line-key');
    const qtyEl = line.querySelector('[data-drawer-qty]');
    const qty = parseInt((qtyEl && qtyEl.value) || '1', 10);

    if (e.target.closest('[data-drawer-minus]')) changeLine(key, Math.max(0, qty - 1));
    else if (e.target.closest('[data-drawer-plus]')) changeLine(key, qty + 1);
    else if (e.target.closest('[data-drawer-remove]')) changeLine(key, 0);
  });

  // Open triggers (header bag icons)
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      if (hasRendered) {
        openDrawer();
        refresh();
      } else {
        refresh().then(() => openDrawer());
      }
    });
  });

  // Close triggers
  drawer.querySelectorAll('[data-cart-drawer-close]').forEach((el) => el.addEventListener('click', closeDrawer));
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  // Focus trap
  drawer.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !isOpen) return;
    const focusables = panel.querySelectorAll('a[href], button:not([disabled]), input:not([readonly]), [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Add-to-cart integration
  document.addEventListener('cart:added', (e) => {
    const cart = e.detail && e.detail.cart;
    if (cart) render(cart);
    else refresh();
    if (autoOpen) openDrawer(e.detail && e.detail.trigger);
  });
})();
